
export interface BalanceSheetEntry {
  id: string;
  user_id: string;
  account_name: string;
  account_type: 'asset' | 'liability' | 'equity';
  account_category: string;
  balance: number;
  period_end_date: string;
  notes?: string;
  created_at: string;
  updated_at: string;
}

export interface BalanceSheetTemplate {
  id: string;
  user_id: string;
  template_name: string;
  template_data: any;
  is_default?: boolean;
  created_at: string;
  updated_at: string;
}

export const ACCOUNT_CATEGORIES = {
  asset: [
    'current_assets',
    'cash_and_equivalents',
    'accounts_receivable',
    'inventory',
    'fixed_assets',
    'property_plant_equipment',
    'intangible_assets',
    'other_assets'
  ],
  liability: [
    'current_liabilities',
    'accounts_payable',
    'short_term_debt',
    'accrued_expenses',
    'long_term_debt',
    'deferred_tax',
    'other_liabilities'
  ],
  equity: [
    'share_capital',
    'retained_earnings',
    'additional_paid_in_capital',
    'treasury_stock',
    'other_equity'
  ]
} as const;
